import { ReactComponent as MailSVG } from '@/asset/svg/mail.svg'
import Input from '@/component/Input'
import React from 'react'

import type { InputProps, InputRef } from 'rc-input'

const EmailInput: React.FC<InputProps & React.RefAttributes<InputRef>> = ({ ...props }) => {
  const prefix = (
    <span className={`flex items-center justify-center`}>
      <MailSVG className="w-6 fill-fontcolor-500" />
    </span>
  )

  return <Input {...props} autoComplete="username" allowClear={true} prefix={prefix} />
}

export default EmailInput
